import { IList } from 'annotation-tools/utils';
import React, { FC, memo, useMemo } from 'react';
import { viewTexts } from '../../../constants/view-texts';
import { ICompanyType } from '../../../types/record/company';
import { IProjectImageInfoType } from '../../../types/record/image-info';
import { IProjectType } from '../../../types/record/project';
import { BreadcrumbsJp } from '../../breadcrumbs/breadcrumbs';
import { ComponentSwitcher } from '../../shared/component-switcher';
import { MuiTabs } from '../../shared/mui/mui-tabs';
import { Full } from '../../shared/styled/full';
import { ProjectDetail } from '../project-detail/project-detail';
import { ProjectImageList } from '../project-image-list/project-image-list';

const vt = viewTexts.pages.projectRoot;

interface Props {
  tabIndex: number;
  tabIndexChange: (idx: number) => void;
  koumutenId: number;
  company: ICompanyType;
  project: IProjectType;
  imageList: IList<IProjectImageInfoType>;
  onEditProjectImagesClick: () => void;
}

export const ProjectRootView: FC<Props> = memo(
  ({
    tabIndex,
    tabIndexChange,
    koumutenId,
    company,
    project,
    imageList,
    onEditProjectImagesClick
  }: Readonly<Props>) => {
    const tabs = useMemo<{ label: string; disabled: boolean }[]>(
      () => [
        { label: vt.tabs.overview, disabled: false },
        {
          label: vt.tabs.projectImageList,
          disabled: project.status === 'approved'
        }
      ],
      [project]
    );

    return (
      <Full>
        <BreadcrumbsJp showPadding={true} />
        <MuiTabs
          tabs={tabs}
          index={tabIndex}
          indexChange={tabIndexChange}
          disableRipple={true}
          disableFocusRipple={true}
        />
        <ComponentSwitcher index={tabIndex}>
          <ProjectDetail
            imageList={imageList}
            onEditProjectImagesClick={onEditProjectImagesClick}
          />
          <ProjectImageList
            koumutenId={koumutenId}
            company={company}
            project={project}
          />
        </ComponentSwitcher>
      </Full>
    );
  }
);

ProjectRootView.displayName = 'ProjectRootView';
